export const GET_ALL_ATTRIBUTE_REQUEST = "GET_ALL_ATTRIBUTE_REQUEST";
export const GET_ALL_ATTRIBUTE_FAILURE = "GET_ALL_ATTRIBUTE_FAILURE";
export const GET_ALL_ATTRIBUTE_SUCCESS = "GET_ALL_ATTRIBUTE_SUCCESS";

export const CREATE_ATTRIBUTE_REQUEST = "CREATE_ATTRIBUTE_REQUEST";
export const CREATE_ATTRIBUTE_FAILURE = "CREATE_ATTRIBUTE_FAILURE";
export const CREATE_ATTRIBUTE_SUCCESS = "CREATE_ATTRIBUTE_SUCCESS";

export const UPDATE_ATTRIBUTE_REQUEST = "UPDATE_ATTRIBUTE_REQUEST";
export const UPDATE_ATTRIBUTE_FAILURE = "UPDATE_ATTRIBUTE_FAILURE";
export const UPDATE_ATTRIBUTE_SUCCESS = "UPDATE_ATTRIBUTE_SUCCESS";

export const DELETE_ATTRIBUTE_REQUEST = "DELETE_ATTRIBUTE_REQUEST";
export const DELETE_ATTRIBUTE_FAILURE = "DELETE_ATTRIBUTE_FAILURE";
export const DELETE_ATTRIBUTE_SUCCESS = "DELETE_ATTRIBUTE_SUCCESS";